import { render, staticRenderFns } from "./AssignClass.vue?vue&type=template&id=2b65caab"
import script from "./AssignClass.vue?vue&type=script&lang=js"
export * from "./AssignClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports